import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { PureComponent } from "react";
class Errors extends PureComponent {
    render() {
        if (this.props.errors && this.props.errors.length) {
            return (_jsx(_Fragment, { children: this.props.errors.map((errorMessage, index) => (_jsxs("div", { className: "alert alert-danger alert-dismissable", children: [_jsx("button", { type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) }), _jsx("span", { className: "fas fa-exclamation-triangle", "aria-hidden": "true" }), " ", errorMessage] }, index))) }));
        }
        return null;
    }
}
Errors.defaultProps = {
    errors: [],
};
export default Errors;
